export default {
  // Navigation Tabs & Menus
  tabs: {
    home: 'Accueil',
    services: 'Services',
    orders: 'Commandes',
    wallet: 'Portefeuille',
    profile: 'Profil',
  },

  nav: {
    dashboard: 'Tableau de bord',
    new_order: 'Nouvelle commande',
    services: 'Services',
    orders: 'Commandes',
    deposit: 'Recharger',
    virtual_numbers: 'Numéros virtuels',
    referrals: 'Parrainage',
    settings: 'Paramètres',
    support: 'Support',
    guide: 'Guide',
    logout: 'Déconnexion',
    login: 'Connexion',
    signup: 'Commencer',
    features: 'Fonctionnalités',
    platforms: 'Plateformes',
    how_it_works: 'Comment ça marche',
    pricing: 'Tarifs',
    faq: 'FAQ',
    language: 'Langue',
  },

  // Common UI
  common: {
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    back: 'Retour',
    submit: 'Soumettre',
    copied: 'Copié dans le presse-papiers',
    search: 'Rechercher...',
    all: 'Tous',
    completed: 'Terminé',
    pending: 'En attente',
    in_progress: 'En cours',
    failed: 'Échoué',
    cancelled: 'Annulé',
    partial: 'Partiel',
    see_all: 'Voir tout',
    details: 'Détails',
    status: 'Statut',
    close: 'Fermer',
    try_again: 'Réessayer',
    error: 'Erreur',
    success: 'Succès',
    something_went_wrong: 'Une erreur est survenue. Veuillez réessayer.',
    rate_per_1k: 'Tarif pour 1 000',
    min_max: 'Min / Max',
    action: 'Action',
    actions: 'Actions',
    category: 'Catégorie',
    service: 'Service',
    quantity: 'Quantité',
    link: 'Lien / URL cible',
    cost: 'Coût',
    total_cost: 'Coût total',
    date: 'Date',
    order: 'Commande',
    refresh: 'Actualiser',
    delivery_time: 'Délai de livraison',
    available_balance: 'Solde disponible',
    add_funds: 'Recharger',
    place_order: 'Commander',
  },

  // Auth Screens
  auth: {
    welcome_title: 'Développez Votre Présence sur les Réseaux',
    welcome_sub: 'La plateforme SMM la plus rapide et fiable pour créateurs et entreprises.',
    login: 'Connexion',
    sign_up: "S'inscrire",
    sign_in: 'Se connecter',
    email_or_username: 'Adresse e-mail ou nom d’utilisateur',
    password: 'Mot de passe',
    remember_me: 'Se souvenir de moi',
    forgot_password: 'Mot de passe oublié ?',
    or_continue_with: 'Ou continuer avec',
    google: 'Google',
    no_account: "Vous n'avez pas de compte ?",
    have_account: 'Vous avez déjà un compte ?',
    create_account: 'Créer un compte',
    full_name: 'Nom complet',
    username: 'Nom d’utilisateur',
    email: 'Adresse e-mail',
    phone: 'Numéro de téléphone',
    confirm_password: 'Confirmer le mot de passe',
    agree_terms: 'J’accepte les Conditions d’utilisation et la Politique de confidentialité',
    reset_password: 'Réinitialiser le mot de passe',
    send_code: 'Envoyer le code',
  },

  // Dashboard Screen
  dashboard: {
    greeting: 'Bonjour',
    grow_subtitle: 'Développez vos comptes sociaux aujourd’hui avec une livraison rapide',
    current_balance: 'Solde actuel',
    your_balance: 'Votre solde',
    add_funds: '+ Recharger',
    quick_actions: 'Actions rapides',
    services_catalog: 'Catalogue de services',
    order_now: 'Commander maintenant',
    track_orders: 'Suivi des commandes',
    wallet_topup: 'Recharger le compte',
    popular_services: 'Services populaires',
    recent_orders: 'Commandes récentes',
    recent_subtitle: 'Suivez vos dernières commandes et l’état de livraison',
    no_orders_yet: 'Aucune commande pour le moment',
    no_orders_desc: 'Sélectionnez un service dans notre catalogue pour propulser vos réseaux.',
    place_first_order: 'Passer une première commande',
    social_media_services: 'Services Réseaux Sociaux',
    social_media_subtitle: 'Boostez vos abonnés, likes et vues',
    virtual_numbers: 'Numéros Virtuels',
    virtual_numbers_subtitle: 'Recevez des codes SMS pour vos vérifications',
    popular_social_media_services: 'Services Réseaux Sociaux Populaires',
    popular_virtual_numbers: 'Numéros Virtuels Populaires',
    fast_and_reliable: 'Livraison Rapide & Automatisée',
    fast_and_reliable_sub: 'Toutes les commandes commencent automatiquement quelques secondes après soumission.',
    total_orders: 'Total des commandes',
    all_time_completed: 'Total finalisé',
    total_spent: 'Total dépensé',
    lifetime_volume: 'Volume cumulé',
    vn_used: 'Numéros virtuels utilisés',
    sms_verifications: 'Vérifications SMS',
    see_all_services: 'Voir tous les services',
    browse_countries: 'Voir tous les pays',
    view_all_orders: 'Toutes les commandes →',
  },

  // Services Screen
  services: {
    title: 'Services',
    subtitle: 'Choisissez parmi plus de 500 offres de croissance pour vos réseaux.',
    promo_title: 'Développez Vos Réseaux Plus Rapidement',
    promo_subtitle: 'Obtenez abonnés, likes, vues et interactions aux meilleurs tarifs vérifiés avec livraison automatique.',
    quick_order: 'Commande Rapide',
    show_all_platforms: 'Toutes les plateformes',
    search_placeholder: 'Rechercher par nom, catégorie ou ID (ex. 1024, TikTok, Instagram)...',
    all_categories: 'Toutes les catégories',
    popular_packages: 'Packs Populaires',
    buy_now: 'Acheter',
    order: 'Commander',
    min: 'Min',
    max: 'Max',
    per_1k: 'pour 1 000',
    instant_delivery: 'Livraison Immédiate',
    high_retention: 'Haute Rétention',
    safe_secure: '100% Sûr et Sécurisé',
    no_services_found: 'Aucun service ne correspond à votre recherche.',
    social_media_tab: 'Réseaux Sociaux',
    virtual_numbers_tab: 'Numéros Virtuels',
    favorites: 'Favoris',
    all_platforms: 'Toutes Plateformes',
    grid_view: 'Cartes',
    table_view: 'Tableau',
  },

  // Virtual Numbers
  virtual_numbers: {
    title: 'Numéros Virtuels',
    subtitle: 'Obtenez des numéros temporaires ou de location pour recevoir des codes de vérification SMS.',
    promo_title: 'Numéros Virtuels Privés Pour Tous Services',
    promo_desc: 'Numéros temporaires pour vérification sur applications et sites web avec réception SMS instantanée.',
    buy_number: 'Acheter un numéro',
    orders: 'Commandes',
    rents: 'Louer un numéro',
    my_numbers: 'Mes numéros',
    instant_delivery: 'Livraison instantanée',
    wide_selection: 'Grand choix de pays',
    affordable_prices: 'Tarifs très abordables',
    popular_countries: 'Pays populaires',
    popular_services: 'Services populaires',
    select_country: 'Sélectionner un pays',
    select_service: 'Sélectionner un service',
    choose_number: 'Choisir le numéro',
    order_summary: 'Récapitulatif de la commande',
    step_payment: 'Paiement',
    continue_payment: 'Procéder au paiement',
    number_activated: 'Numéro activé',
    number_ready: 'Votre numéro virtuel est prêt à être utilisé.',
    time_remaining: 'Temps restant',
    received_codes: 'Codes reçus',
    no_codes_yet: 'Aucun code reçu pour le moment',
    codes_auto_appear: 'Les codes SMS reçus pour ce numéro s’afficheront ici automatiquement.',
    instructions_text: 'Ouvrez l’application et saisissez ce numéro. Les nouveaux SMS apparaîtront en direct.',
    extend: 'Prolonger',
    rent_again: 'Louer à nouveau',
    cancel: 'Annuler',
    all_codes: 'Tous les codes',
    unread: 'Non lus',
    available: 'Disponible',
    refresh: 'Actualiser',
    phone_number: 'Numéro de téléphone',
    view_all: 'Voir tout >',
    select_provider: 'Sélectionner un fournisseur',
    live_rates: 'Tarifs en direct',
    choose_provider_sub: 'Choisissez votre fournisseur de numéros virtuels préféré :',
    instant_sms_desc: 'Vérification SMS instantanée',
    global_pool_desc: 'Couverture internationale et large choix',
    country: 'Pays',
    service: 'Service',
    provider: 'Fournisseur',
    price: 'Prix',
    auto_assigned: 'Attribué automatiquement à l’achat',
    pay_activate_btn: 'Payer & Activer le numéro',
    number_details: 'Détails du numéro',
    number_details_sub: 'Votre numéro est actif. Utilisez-le pour recevoir vos codes SMS.',
    waiting_for_code: 'En attente du code SMS...',
    instructions: 'Instructions',
    instructions_prefix: 'Ouvrez',
    instructions_suffix: 'et entrez ce numéro pour recevoir le code de vérification.',
    view_all_received_codes: 'Voir tous les codes reçus →',
    search_service_placeholder: 'Rechercher un service (WhatsApp, Telegram...)',
    search_country_placeholder: 'Rechercher un pays...',
    no_services_found: 'Aucun service trouvé',
    no_countries_found: 'Aucun pays trouvé',
    no_numbers_yet: 'Aucun numéro pour le moment',
    no_numbers_sub: 'Vos numéros virtuels achetés apparaîtront ici.',
    buy_a_number: 'Acheter un numéro',
    my_rents: 'Mes locations',
    my_rents_sub: 'Gérez vos numéros loués, prolongez la durée et suivez leur statut.',
    search_rent_placeholder: 'Rechercher numéro, service ou pays...',
    active: 'Actif',
    expiring: 'Expire bientôt',
    expired: 'Expiré',
    all: 'Tous',
    back_to_services: '‹ Retour aux services',
    back_to_countries: '‹ Retour aux pays',
    select_country_continue: 'Sélectionnez un pays pour continuer votre commande',
    success_rate: 'Taux de succès',
    confirm_purchase_title: 'Confirmer l’achat du numéro',
    confirm_purchase_sub: 'Vérifiez les détails de votre commande avant d’activer le numéro.',
    total_deducted: 'Montant qui sera déduit',
    your_new_balance: 'Votre solde après achat',
    insufficient_balance: 'Solde insuffisant pour acheter ce numéro.',
    deposit_to_continue: 'Veuillez recharger votre portefeuille pour continuer.',
  },

  // New Order Screen
  new_order: {
    title: 'Nouvelle Commande',
    subtitle: 'Entrez le lien de votre profil ou publication et la quantité désirée.',
    service_selected: 'Service sélectionné',
    category_label: 'Catégorie',
    select_category: 'Sélectionner une catégorie',
    service_label: 'Service',
    select_service: 'Sélectionner un service',
    link_label: 'Lien / URL cible',
    link_placeholder: 'https://instagram.com/votreprofil ou lien de publication',
    link_helper: 'Assurez-vous que le compte ou la publication soit public(que)',
    quantity_label: 'Quantité',
    min_max: 'Min : {min} — Max : {max}',
    total_price: 'Prix total',
    place_order_btn: 'Confirmer la commande',
    order_success_title: 'Commande créée avec succès !',
    order_success_sub: 'Votre commande est en cours de traitement et sera livrée très rapidement.',
    order_id: 'Numéro de commande',
    track_orders_btn: 'Voir dans mes commandes',
    back_to_services_btn: 'Retour aux services',
    comments_label: 'Commentaires personnalisés',
    comments_placeholder: 'Entrez un commentaire par ligne...',
    comments_badge: '{count} commentaire(s)',
    rate_per_1k: 'Tarif / 1 000',
    delivery_time: 'Délai de livraison',
    service_description: 'Description du service',
    quick_presets: 'Quantités rapides',
    insufficient_balance: 'Solde insuffisant',
    insufficient_sub: 'Votre solde est insuffisant pour valider cette commande.',
    deposit_now: 'Recharger maintenant',
    order_summary: 'Récapitulatif de la commande',
  },

  // Orders Screen
  orders: {
    title: 'Mes Commandes',
    subtitle: 'Suivez en direct l’avancement et le statut de vos commandes.',
    search_placeholder: 'Rechercher par #ID, nom de service ou URL...',
    filter_all: 'Toutes',
    filter_pending: 'En attente',
    filter_progress: 'En cours',
    filter_completed: 'Terminées',
    filter_partial: 'Partielles',
    filter_cancelled: 'Annulées',
    no_orders_found: 'Aucune commande ne correspond à ce filtre.',
    progress: 'Progression de livraison',
    view_cards: 'Cartes',
    view_table: 'Tableau',
    order_num: 'Commande',
    service_col: 'Service',
    quantity_col: 'Quantité',
    cost_col: 'Coût',
    status_col: 'Statut',
    date_col: 'Date',
    link_col: 'Lien',
    copy_link: 'Copier le lien',
    open_link: 'Ouvrir le lien',
  },

  // Wallet / Deposit Screen
  wallet: {
    title: 'Portefeuille',
    subtitle: 'Rechargez votre solde pour commander vos services en toute simplicité.',
    current_balance: 'Solde disponible',
    add_funds: 'Recharger',
    transaction_history: 'Historique des transactions',
    select_amount: 'Choisir un montant',
    custom_amount: 'Montant personnalisé',
    enter_amount_placeholder: 'Entrez le montant (ex. 5000)',
    select_payment_method: '1. Choisir le moyen de paiement',
    phone_number: 'Numéro de téléphone',
    proceed_to_payment: 'Procéder au paiement',
    secure_payments: 'Paiements 100% sécurisés et cryptés.',
    instant_addition: 'Les fonds sont ajoutés automatiquement après validation.',
    recent_transactions: 'Transactions récentes',
    bonus_title: 'Bonus de Premier Dépôt Activé !',
    bonus_desc: 'Profitez d’un bonus crédité immédiatement sur votre solde lors de votre premier dépôt !',
    quick_amounts: 'Montants rapides',
    one_tap_fill: 'En 1 clic',
    amount_in: 'Montant en {currency}',
    depositing: 'Montant rechargé',
    credited_to_wallet: 'Crédité sur votre portefeuille',
    no_transactions: 'Aucune transaction',
    no_transactions_sub: 'Vos dépôts et remboursements apparaîtront ici.',
    pay_now: 'Payer maintenant',
  },

  // Settings Screen
  settings: {
    title: 'Paramètres du compte',
    subtitle: 'Gérez vos préférences de profil, devise régionale, sécurité et accès API.',
    tab_preferences: 'Préférences & Devise',
    tab_security: 'Sécurité & Mot de passe',
    tab_api: 'Clé API & Revendeur',
    loc_title: 'Localisation, Devise & Langue',
    loc_subtitle: 'Définissez votre pays, langue préférée et devise pour vos commandes et paiements.',
    field_country: 'Pays principal',
    field_country_desc: 'Les paiements Mobile Money et options locales utiliseront ce pays par défaut.',
    field_currency: 'Devise d\'affichage du compte',
    field_language: 'Langue préférée',
    field_language_desc: 'Sélectionnez la langue d\'affichage de la plateforme et des notifications.',
    btn_save_preferences: 'Enregistrer les préférences',
    btn_saving_preferences: 'Mise à jour en cours...',
    msg_preferences_saved: 'Préférences mises à jour avec succès !',
    security_title: 'Changer le mot de passe',
    security_sub: 'Protégez votre compte en utilisant un mot de passe sécurisé.',
    current_password: 'Mot de passe actuel',
    new_password: 'Nouveau mot de passe',
    confirm_new_password: 'Confirmer le nouveau mot de passe',
    btn_update_password: 'Mettre à jour le mot de passe',
    api_title: 'Accès API & Revendeur',
    api_sub: 'Intégrez directement les services NiceBooster dans votre propre application ou panel SMM.',
    api_key_label: 'Votre clé secrète API',
    generate_key: 'Générer une nouvelle clé',
    copy_key: 'Copier la clé',
    reseller_status: 'Accès API Revendeur',
  },

  // Support Screen
  support: {
    title: 'Aide & Support',
    subtitle: 'Contactez notre équipe d’assistance disponible 24h/24 et 7j/7.',
    whatsapp_chat: 'Discuter sur WhatsApp',
    whatsapp_desc: 'Réponse la plus rapide — en moins de 5 minutes',
    telegram_chat: 'Support Telegram',
    telegram_desc: 'Assistance instantanée avec nos conseillers',
    email_support: 'Support par e-mail',
    email_desc: 'Pour la facturation ou les partenariats',
  },

  // Landing Page
  landing: {
    hero_title_1: 'Accélérez votre croissance sur les réseaux au',
    hero_title_2: 'Tarif de Gros',
    hero_subtitle: 'La plateforme automatisée tout-en-un pour créateurs, agences et entreprises. Boostez vos abonnés, likes, vues et obtenez des numéros virtuels instantanés pour vos vérifications SMS.',
    hero_cta_free: 'Commencer gratuitement',
    hero_view_catalog: 'Voir le catalogue de services',
    hero_trusted: 'Approuvé par 50 000+ créateurs • MoMo & Crypto acceptés',
    stat_delivered_today: 'Livrées aujourd\'hui',
    stat_sms_received: 'Codes SMS reçus',
    stat_orders_completed: 'Commandes livrées',
    stat_active_creators: 'Créateurs & agences actifs',
    stat_uptime: 'Disponibilité du système',
    stat_speed: 'Délai moyen de démarrage',
    live_order_network: 'Réseau de commandes en direct',
    recent_activity: 'Activité récente',
    final_cta_title: 'Propulsez votre présence en ligne dès aujourd\'hui',
    final_cta_subtitle: 'Rejoignez plus de 50 000 créateurs, marques et agences qui se développent facilement avec NiceBooster.',
    create_free_account: 'Créer un compte gratuit',
    talk_to_support: 'Parler au support',
    footer_nav: 'Navigation',
    footer_account: 'Compte',
    footer_support: 'Support & Légal',
  },

  // Flat keys for backwards compatibility
  nav_dashboard: 'Tableau de bord',
  nav_new_order: 'Nouvelle commande',
  nav_services: 'Services',
  nav_orders: 'Commandes',
  nav_deposit: 'Recharger',
  nav_virtual_numbers: 'Numéros virtuels',
  nav_referrals: 'Parrainage',
  nav_settings: 'Paramètres',
  nav_support: 'Support',
  nav_guide: 'Guide',
  nav_logout: 'Déconnexion',
  nav_login: 'Connexion',
  nav_signup: 'Commencer',
  nav_features: 'Fonctionnalités',
  nav_platforms: 'Plateformes',
  nav_how_it_works: 'Comment ça marche',
  nav_pricing: 'Tarifs',
  nav_faq: 'FAQ',
  nav_language: 'Langue',
  settings_title: 'Paramètres du compte',
  settings_subtitle: 'Gérez vos préférences de profil, devise régionale, sécurité et accès API.',
  tab_preferences: 'Préférences & Devise',
  tab_security: 'Sécurité & Mot de passe',
  tab_api: 'Clé API & Revendeur',
  loc_title: 'Localisation, Devise & Langue',
  loc_subtitle: 'Définissez votre pays, langue préférée et devise pour vos commandes et paiements.',
  field_country: 'Pays principal',
  field_country_desc: 'Les paiements Mobile Money et options locales utiliseront ce pays par défaut.',
  field_currency: 'Devise d\'affichage du compte',
  field_language: 'Langue préférée',
  field_language_desc: 'Sélectionnez la langue d\'affichage de la plateforme et des notifications.',
  btn_save_preferences: 'Enregistrer les préférences',
  btn_saving_preferences: 'Mise à jour en cours...',
  msg_preferences_saved: 'Préférences mises à jour avec succès !',
  dash_smm_services: 'Services Réseaux Sociaux',
  dash_smm_desc: 'Boostez vos abonnés, likes, vues et engagements sur toutes les plateformes',
  dash_vn_title: 'Numéros Virtuels',
  dash_vn_desc: 'Recevez instantanément des codes SMS de vérification avec des numéros privés',
  dash_popular_smm: 'Services Réseaux Sociaux Populaires',
  dash_see_all_services: 'Voir tous les services',
  dash_popular_vn: 'Numéros Virtuels Populaires',
  dash_browse_countries: 'Voir tous les pays',
  dash_top_up: '+ Recharger',
  dash_total_orders: 'Total des commandes',
  dash_all_time_completed: 'Total finalisé',
  dash_total_spent: 'Total dépensé',
  dash_lifetime_volume: 'Volume cumulé',
  dash_vn_used: 'Numéros virtuels utilisés',
  dash_sms_verifications: 'Vérifications SMS',
  dash_recent_orders: 'Commandes récentes',
  dash_recent_subtitle: 'Suivez vos dernières commandes et l\'état de livraison',
  dash_refresh: 'Actualiser',
  dash_view_all_orders: 'Toutes les commandes →',
  col_order: 'Commande',
  col_service: 'Service',
  col_quantity: 'Quantité',
  col_cost: 'Coût',
  col_status: 'Statut',
  col_date: 'Date',
  no_orders_placed: 'Aucune commande pour le moment',
  no_orders_desc: 'Sélectionnez un service dans notre catalogue pour propulser vos réseaux.',
  place_first_order: 'Passer une première commande',
  hero_title_1: 'Accélérez votre croissance sur les réseaux au',
  hero_title_2: 'Tarif de Gros',
  hero_subtitle: 'La plateforme automatisée tout-en-un pour créateurs, agences et entreprises. Boostez vos abonnés, likes, vues et obtenez des numéros virtuels instantanés pour vos vérifications SMS.',
  hero_cta_free: 'Commencer gratuitement',
  hero_view_catalog: 'Voir le catalogue de services',
  hero_trusted: 'Approuvé par 50 000+ créateurs • MoMo & Crypto acceptés',
  stat_delivered_today: 'Livrées aujourd\'hui',
  stat_sms_received: 'Codes SMS reçus',
  stat_orders_completed: 'Commandes livrées',
  stat_active_creators: 'Créateurs & agences actifs',
  stat_uptime: 'Disponibilité du système',
  stat_speed: 'Délai moyen de démarrage',
  live_order_network: 'Réseau de commandes en direct',
  recent_activity: 'Activité récente',
  final_cta_title: 'Propulsez votre présence en ligne dès aujourd\'hui',
  final_cta_subtitle: 'Rejoignez plus de 50 000 créateurs, marques et agences qui se développent facilement avec NiceBooster.',
  create_free_account: 'Créer un compte gratuit',
  talk_to_support: 'Parler au support',
  footer_nav: 'Navigation',
  footer_account: 'Compte',
  footer_support: 'Support & Légal',
  available_balance: 'Solde disponible',
  add_funds: 'Recharger',
  place_order: 'Commander',
  category: 'Catégorie',
  service: 'Service',
  quantity: 'Quantité',
  link: 'Lien',
  total_cost: 'Coût total',
  status: 'Statut',
  actions: 'Actions',
  search: 'Rechercher',
  cancel: 'Annuler',
  loading: 'Chargement...',
  close: 'Fermer',
};
